import script from "./RegisterConsultantPage.vue?vue&type=script&setup=true&lang=js"
export * from "./RegisterConsultantPage.vue?vue&type=script&setup=true&lang=js"

import "./RegisterConsultantPage.vue?vue&type=style&index=0&id=1d625e6d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d625e6d"]])

export default __exports__